import NumberFormatter from '../../../formatters/NumberFormatter';

const numberFormatter = new NumberFormatter();

/*
 * RAS-14272
 * stockanalysisIndicatorsGet servisi gösterge adlarını culture'a göre lokalize
 * döndürüyor ve IndicatorInfo modelinde dilden bağımsız bir kod alanı yok. Bu
 * yüzden eşleştirme, her göstergenin TR + EN adlarının ortak listesi üzerinden
 * yapılıyor; aksi halde İngilizce'de yalnızca Türkçe adlara bakan kontroller
 * tutmuyor ve ondalık basamak / ay adı / satır sırası iki dilde farklılaşıyor.
 */
const INDICATOR_ALIASES = {
    marketCap: ['Piyasa Değeri (mn.)', 'Market Capitalization (mn.)'],
    volume: ['İşlem Miktarı', 'Volume'],
    value: ['İşlem Hacmi', 'Value'],
    avgValue6M: ['6 Ay. Ort. Hacim', '6A Ort.Hacim', '6M Avg.Value'],
    numberOfShares: ['Hisse Adedi', 'Number of Shares'],
    fiscalYearEnd: ['Mali Yıl Sonu', 'End of Fiscal Year'],
};

// Binlik gruplu büyük değerler ondalık gösterilmiyor.
const WITHOUT_DECIMALS = ['marketCap', 'volume', 'value', 'avgValue6M', 'numberOfShares', 'fiscalYearEnd'];

// "İşlem Hacmi" satırı 6 aylık ortalama hacimden sonra gelmeli.
const ORDER_OVERRIDES = { value: 7 };

const MONTH_KEYS = [
    'date.months.january', 'date.months.february', 'date.months.march',
    'date.months.april', 'date.months.may', 'date.months.june',
    'date.months.july', 'date.months.august', 'date.months.september',
    'date.months.october', 'date.months.november', 'date.months.december',
];

/*
 * Türkçe "İ" harfi toLowerCase() ile "i" + birleşik nokta (U+0307) üretir;
 * karşılaştırmanın iki tarafı da aynı normalizasyondan geçtiği için nokta
 * temizlenerek "İşlem" ile "işlem" eşleşebiliyor.
 */
const normalize = (name) => (name === null || name === undefined ? '' : String(name))
    .trim()
    .toLowerCase()
    .replace(/\u0307/g, '');

const ALIAS_LOOKUP = Object.entries(INDICATOR_ALIASES).reduce((lookup, [key, names]) => {
    names.forEach((name) => { lookup[normalize(name)] = key; });
    return lookup;
}, {});

const indicatorKeyOf = (name) => ALIAS_LOOKUP[normalize(name)];

const capitalizeFirstLetter = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text);

/**
 * Önemli Göstergeler panelinin servis çıktısını dilden bağımsız olarak biçimlendirir.
 *
 * @param {Array<{name?: string, value?: number, order?: number}>} items servisten gelen ham göstergeler
 * @param {(key: string) => string} t i18next çeviri fonksiyonu (ay adları için)
 * @returns {Array<{name: string, value: string, order: number}>} biçimlendirilmiş, sıralanmış yeni liste
 */
export const formatIndicators = (items, t) => {
    if (!Array.isArray(items)) {
        return [];
    }

    return items
        .map((item) => {
            const key = indicatorKeyOf(item.name);
            const precision = WITHOUT_DECIMALS.includes(key) ? 0 : 2;

            let value;
            if (key === 'fiscalYearEnd') {
                const monthKey = MONTH_KEYS[Number(item.value) - 1];
                value = monthKey ? t(monthKey) : numberFormatter.Double(item.value, precision);
            } else if (item.value === null || item.value === undefined) {
                value = item.value;
            } else {
                value = numberFormatter.Double(item.value, precision);
            }

            return {
                ...item,
                name: capitalizeFirstLetter(item.name),
                value,
                order: ORDER_OVERRIDES[key] !== undefined ? ORDER_OVERRIDES[key] : item.order,
            };
        })
        .sort((a, b) => (a.order || 0) - (b.order || 0));
};

export default formatIndicators;
